import { render, staticRenderFns } from "./r-video.vue?vue&type=template&id=09417166&"
import script from "./r-video.vue?vue&type=script&lang=js&"
export * from "./r-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports